import { t } from '@lingui/core/macro';
import { DateRangeFilter } from './DateFilter';
export const updatedAtFilterLabel = () => t({
    message: 'Updated at',
    comment: 'Insights: Updated at filter',
});
export function UpdatedAtFilter() {
    return <DateRangeFilter name="updatedAt" label={updatedAtFilterLabel()}/>;
}
